'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Refresh = function Refresh(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 14 14' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M9 9.875l3.25.042a6.527 6.527 0 0 1-5.472 2.964A5.99 5.99 0 0 1 1.017 7h-1a6.7 6.7 0 0 0 6.762 6.881A7.941 7.941 0 0 0 13 10.667V14h1V9H9v.875zm-4-5.75l-3.242-.041a6.535 6.535 0 0 1 5.476-2.965A6 6 0 0 1 13 7h1A6.709 6.709 0 0 0 7.231.119 7.964 7.964 0 0 0 1 3.333V0H0v5h5v-.875z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = Refresh;
//# sourceMappingURL=Refresh.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Refresh.js